import api from '@/helpers/api';
import ProgressStates from '../../../helpers/lists/progressStates';

let canStatisticsBeReloaded = true;
let statisticsUnlockTimeout = null;
let lastResync = null;

function resetStatisticsReloadTimer() {
  canStatisticsBeReloaded = false;
  clearTimeout(statisticsUnlockTimeout);
  statisticsUnlockTimeout = setTimeout(() => {
    canStatisticsBeReloaded = true;
  }, 1000 * 60 * 5); // 5 minutes
}

const actions = {
  initialized({ commit }, status) {
    commit('ORGANISATION_INITIALIZED', status);
  },
  addMemberToBusiness(
    {
      commit,
      state,
      dispatch,
      getters,
    },
    payload,
  ) {
    payload.me = getters.me;
    const targetMember = state.organisationMembersLookup[payload.user_uid];
    if (targetMember) {
      if (!state.organisationNumbers && !state.loadingOrganisationNumbers) {
        dispatch('fetchOrganisationNumbers');
        setTimeout(() => {
          dispatch('addMemberToBusiness', payload);
        }, 1000);
      } else if (!state.organisationNumbers && state.loadingOrganisationNumbers) {
        setTimeout(() => {
          dispatch('addMemberToBusiness', payload);
        }, 1000);
      } else {
        commit('ADD_MEMBER_TO_BUSINESS', payload);
      }
    }
  },
  removeMemberFormBusiness({ commit, getters }, payload) {
    payload.me = getters.me;
    commit('REMOVE_MEMBER_FROM_BUSINESS', payload);
  },
  fetchOrganisationNumbers({ state, commit }) {
    commit('LOADING_ORGANISATION_NUMBERS', true);
    api('GET', `organisation/${state.currentOrganisation.id}/business-numbers`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_ORGANISATION_NUMBERS', response.data);
        } else {
          commit('SET_ORGANISATION_NUMBERS', []);
        }
      })
      .finally(() => {
        commit('LOADING_ORGANISATION_NUMBERS', false);
      });
  },
  fetchOrganisationNumber({ commit, state }, numberIds) {
    // business_ids accepts ids separated by ','
    const request = api('GET', `organisation/${state.currentOrganisation.id}/business-numbers`, { business_ids: numberIds }, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('SET_ORGANISATION_NUMBER', response.data);
        }
      });
    return request;
  },
  fetchOrganisations({ commit }) {
    commit('ORGANISATION_LIST_SET_LOADING');
    const request = api('GET', 'organisation/data', null, null, 'w');
    request
      .then(
        (response) => {
          // response.data.push(
          //   {
          //     "id": "448867a5-e511-4ab8-aec9-9fd094ca8a7a",
          //     "name": "test",
          //     "legal_merchant_name": null,
          //     "legal_entity_type": null,
          //     "email": null,
          //     "website": null,
          //     "logo": "https://sendbee-dev.s3.amazonaws.com/a-captain-underpants-movie-is-on-the-way-03-e1482784107381.jpg",
          //     "plan": "1 x Monthly subscription ($250 USD / month), 1 x Template messages ($0.04 USD / month)",
          //     "plan_active": false,
          //     "slug": "test",
          //     "phone": "+1234567893",
          //     "unread_conversations": {
          //       "unassigned_unread": 0,
          //       "all_unread": 0,
          //       "user_unread": {
          //         "559a42d1-9662-430f-8664-8294bed16346": 0
          //       }
          //     },
          //     "address": "test",
          //     "about": "",
          //     "description": "",
          //     "available": false
          //   },
          //   {
          //     "id": "1f9730b7-bcdc-4547-9d92-4caa70a60643",
          //     "name": "AI Number",
          //     "legal_merchant_name": null,
          //     "legal_entity_type": null,
          //     "email": "ivan@number.tm ",
          //     "website": "https://number.tm ",
          //     "logo": "",
          //     "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)",
          //     "plan_active": true,
          //     "slug": "number",
          //     "phone": "+13253077759",
          //     "unread_conversations": {
          //       "unassigned_unread": 0,
          //       "all_unread": 0,
          //       "user_unread": {
          //         "559a42d1-9662-430f-8664-8294bed16346": 0
          //       }
          //     },
          //     "address": "Ulica BB",
          //     "about": "Ovo je tesni Number account.",
          //     "description": "Ovo je tesni Number account.",
          //     "available": false
          //   },
          //   {
          //     "id": "448867a5-e511-4ab8-aec9-9fd094ca8a7a",
          //     "name": "test",
          //     "legal_merchant_name": null,
          //     "legal_entity_type": null,
          //     "email": null,
          //     "website": null,
          //     "logo": "https://sendbee-dev.s3.amazonaws.com/a-captain-underpants-movie-is-on-the-way-03-e1482784107381.jpg",
          //     "plan": "1 x Monthly subscription ($250 USD / month), 1 x Template messages ($0.04 USD / month)",
          //     "plan_active": false,
          //     "slug": "test",
          //     "phone": "+1234567893",
          //     "unread_conversations": {
          //       "unassigned_unread": 0,
          //       "all_unread": 0,
          //       "user_unread": {
          //         "559a42d1-9662-430f-8664-8294bed16346": 0
          //       }
          //     },
          //     "address": "test",
          //     "about": "",
          //     "description": "",
          //     "available": false
          //   },
          //   {
          //     "id": "1f9730b7-bcdc-4547-9d92-4caa70a60643",
          //     "name": "AI Number",
          //     "legal_merchant_name": null,
          //     "legal_entity_type": null,
          //     "email": "ivan@number.tm ",
          //     "website": "https://number.tm ",
          //     "logo": "",
          //     "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)",
          //     "plan_active": true,
          //     "slug": "number",
          //     "phone": "+13253077759",
          //     "unread_conversations": {
          //       "unassigned_unread": 0,
          //       "all_unread": 0,
          //       "user_unread": {
          //         "559a42d1-9662-430f-8664-8294bed16346": 0
          //       }
          //     },
          //     "address": "Ulica BB",
          //     "about": "Ovo je tesni Number account.",
          //     "description": "Ovo je tesni Number account.",
          //     "available": false
          //   },
          //   {
          //     "id": "448867a5-e511-4ab8-aec9-9fd094ca8a7a",
          //     "name": "test",
          //     "legal_merchant_name": null,
          //     "legal_entity_type": null,
          //     "email": null,
          //     "website": null,
          //     "logo": "https://sendbee-dev.s3.amazonaws.com/a-captain-underpants-movie-is-on-the-way-03-e1482784107381.jpg",
          //     "plan": "1 x Monthly subscription ($250 USD / month), 1 x Template messages ($0.04 USD / month)",
          //     "plan_active": false,
          //     "slug": "test",
          //     "phone": "+1234567893",
          //     "unread_conversations": {
          //       "unassigned_unread": 0,
          //       "all_unread": 0,
          //       "user_unread": {
          //         "559a42d1-9662-430f-8664-8294bed16346": 0
          //       }
          //     },
          //     "address": "test",
          //     "about": "",
          //     "description": "",
          //     "available": false
          //   },
          //   {
          //     "id": "1f9730b7-bcdc-4547-9d92-4caa70a60643",
          //     "name": "AI Number",
          //     "legal_merchant_name": null,
          //     "legal_entity_type": null,
          //     "email": "ivan@number.tm ",
          //     "website": "https://number.tm ",
          //     "logo": "",
          //     "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)",
          //     "plan_active": true,
          //     "slug": "number",
          //     "phone": "+13253077759",
          //     "unread_conversations": {
          //       "unassigned_unread": 0,
          //       "all_unread": 0,
          //       "user_unread": {
          //         "559a42d1-9662-430f-8664-8294bed16346": 0
          //       }
          //     },
          //     "address": "Ulica BB",
          //     "about": "Ovo je tesni Number account.",
          //     "description": "Ovo je tesni Number account.",
          //     "available": false
          //   },
          // );
          // response.data = [];
          if (response.status === 200) {
            // response.data[0].should_activate_account = true;
            // response.data[0].activate_items = { "licenced_items": [{ "unit_amount": 249.0, "quantity": 2, "name": "$250", "description": "Monthly subscription", "currency": "usd", "amount": 498.0, "proration": false }], "overall_amount": 658.58 };
            // response.data[0].should_reactivate_account = true;
            // response.data[0].activate_items = [{ "id": "in_1Lo47kEYwMGybr6ckfC9GmIs", "status": "failed", "hosted_invoice_url": "https://invoice.stripe.com/i/acct_1ENeVMEYwMGybr6c/test_YWNjdF8xRU5lVk1FWXdNR3licjZjLF9NWDhPM3ZtTlpndU1BZ3Y5cTg4S0NJR1hTS2VOT0RkLDU1MjM2Nzky0200UzdMD3hn?s=ap", "invoice_pdf": "https://pay.stripe.com/invoice/acct_1ENeVMEYwMGybr6c/test_YWNjdF8xRU5lVk1FWXdNR3licjZjLF9NWDhPM3ZtTlpndU1BZ3Y5cTg4S0NJR1hTS2VOT0RkLDU1MjM2Nzky0200UzdMD3hn/pdf?s=ap", "created_at": 1664695987.0, "total": 249.0, "total_excluding_tax": 249.0, "refund_amount": 0.0, "paid_at": 1664695987.0 }, { "id": "in_1LdBkzEYwMGybr6chOIhgoPy", "status": "failed", "hosted_invoice_url": "https://invoice.stripe.com/i/acct_1ENeVMEYwMGybr6c/test_YWNjdF8xRU5lVk1FWXdNR3licjZjLF9NTHRZQUNWRTFZaXN5RmhLYUtNdHpiSUhNa1E2SVI3LDUyNTczMjQw0200ZKMchYE4?s=ap", "invoice_pdf": "https://pay.stripe.com/invoice/acct_1ENeVMEYwMGybr6c/test_YWNjdF8xRU5lVk1FWXdNR3licjZjLF9NTHRZQUNWRTFZaXN5RmhLYUtNdHpiSUhNa1E2SVI3LDUyNTczMjQw0200ZKMchYE4/pdf?s=ap", "created_at": 1662032431.0, "total": 249.0, "total_excluding_tax": 249.0, "refund_amount": 0.0, "paid_at": 1662032432.0 }, { "id": "in_1LXOnMEYwMGybr6cCjeWK13j", "status": "failed", "hosted_invoice_url": "https://invoice.stripe.com/i/acct_1ENeVMEYwMGybr6c/test_YWNjdF8xRU5lVk1FWXdNR3licjZjLF9NRnVjcFRzcXBoRDJGRnFHaU5pTGJIeHBpb3dmdkpmLDUxMTkzNzY50200Djp3DTPT?s=ap", "invoice_pdf": "https://pay.stripe.com/invoice/acct_1ENeVMEYwMGybr6c/test_YWNjdF8xRU5lVk1FWXdNR3licjZjLF9NRnVjcFRzcXBoRDJGRnFHaU5pTGJIeHBpb3dmdkpmLDUxMTkzNzY50200Djp3DTPT/pdf?s=ap", "created_at": 1660652583.0, "total": 250.0, "total_excluding_tax": 250.0, "refund_amount": 0.0, "paid_at": null }, { "id": "in_1LXOkiEYwMGybr6ctBEYUQ9b", "status": "paid", "hosted_invoice_url": "https://invoice.stripe.com/i/acct_1ENeVMEYwMGybr6c/test_YWNjdF8xRU5lVk1FWXdNR3licjZjLF9NRnVaV0Vjd1o5bG04b2ZpNWxPWkJBR1Q0S0dGeHhqLDUxMTk1Njg40200nXz4Veu4?s=ap", "invoice_pdf": "https://pay.stripe.com/invoice/acct_1ENeVMEYwMGybr6c/test_YWNjdF8xRU5lVk1FWXdNR3licjZjLF9NRnVaV0Vjd1o5bG04b2ZpNWxPWkJBR1Q0S0dGeHhqLDUxMTk1Njg40200nXz4Veu4/pdf?s=ap", "created_at": 1660652418.0, "total": 250.0, "total_excluding_tax": 250.0, "refund_amount": 213.88, "paid_at": 1660652420.0 }, { "id": "in_1LT3vAEYwMGybr6cJ4CxT4TE", "status": "paid", "hosted_invoice_url": "https://invoice.stripe.com/i/acct_1ENeVMEYwMGybr6c/test_YWNjdF8xRU5lVk1FWXdNR3licjZjLF9NQlFtUjZUdjEzTmxPZ1lxcDl4SDE0VGhYSEF1c3l0LDUxMTkzNzY50200UMETMyle?s=ap", "invoice_pdf": "https://pay.stripe.com/invoice/acct_1ENeVMEYwMGybr6c/test_YWNjdF8xRU5lVk1FWXdNR3licjZjLF9NQlFtUjZUdjEzTmxPZ1lxcDl4SDE0VGhYSEF1c3l0LDUxMTkzNzY50200UMETMyle/pdf?s=ap", "created_at": 1659619024.0, "total": 224.36, "total_excluding_tax": 224.36, "refund_amount": 133.45, "paid_at": 1659619023.0 }, { "id": "in_1LT3kFEYwMGybr6ckq7VvNAX", "status": "paid", "hosted_invoice_url": "https://invoice.stripe.com/i/acct_1ENeVMEYwMGybr6c/test_YWNjdF8xRU5lVk1FWXdNR3licjZjLF9NQlFiRHdOS2JzZWZiSTNwRTJBN2Zrakk5aVZORURiLDUxMTk4OTg20200Wd9xjdUg?s=ap", "invoice_pdf": "https://pay.stripe.com/invoice/acct_1ENeVMEYwMGybr6c/test_YWNjdF8xRU5lVk1FWXdNR3licjZjLF9NQlFiRHdOS2JzZWZiSTNwRTJBN2Zrakk5aVZORURiLDUxMTk4OTg20200Wd9xjdUg/pdf?s=ap", "created_at": 1659618347.0, "total": 224.42, "total_excluding_tax": 224.42, "refund_amount": 123.33, "paid_at": 1659618347.0 }, { "id": "in_1LT2OoEYwMGybr6cNyGFDiub", "status": "paid", "hosted_invoice_url": "https://invoice.stripe.com/i/acct_1ENeVMEYwMGybr6c/test_YWNjdF8xRU5lVk1FWXdNR3licjZjLF9NQlBEalF0SVg2bGg4OUVRMG52WGxJbVlhbmlYbU52LDUxMTkzNzY50200ujfnbmXV?s=ap", "invoice_pdf": "https://pay.stripe.com/invoice/acct_1ENeVMEYwMGybr6c/test_YWNjdF8xRU5lVk1FWXdNR3licjZjLF9NQlBEalF0SVg2bGg4OUVRMG52WGxJbVlhbmlYbU52LDUxMTkzNzY50200ujfnbmXV/pdf?s=ap", "created_at": 1659613174.0, "total": 224.9, "total_excluding_tax": 224.9, "refund_amount": 0.0, "paid_at": 1659613174.0 }];
            // response.data[0].should_reactivate_account = true;
            commit('ORGANISATION_LIST_SET_DATA', response.data);
          }
        },
      )
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },
  fetchCurrentOrganisation({ commit, dispatch }, organisationId) {
    commit('CURRENT_ORGANISATION_SET_LOADING');
    // @todo: replace with proper call to get only one (requested) organisation
    api('GET', `organisation/${organisationId}/data`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          // commit to store
          // Test mock data
          // response.data.businesses.push(
          //     {
          //       "id": "1f9730b7-bcdc-4547-9d92-4caa70a60643",
          //       "name": "AI Number",
          //       "legal_merchant_name": null,
          //       "legal_entity_type": null,
          //       "email": "ivan@number.tm ",
          //       "website": "https://number.tm ",
          //       "logo": "",
          //       "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)",
          //       "plan_active": true,
          //       "slug": "number",
          //       "phone": "+13253077759",
          //       "unread_conversations": {
          //         "unassigned_unread": 0,
          //         "all_unread": 0,
          //         "user_unread": {
          //           "559a42d1-9662-430f-8664-8294bed16346": 0
          //         }
          //       },
          //       "address": "Ulica BB",
          //       "about": "Ovo je tesni Number account.",
          //       "description": "Ovo je tesni Number account.",
          //       "available": false
          //     },
          //     {
          //       "id": "448867a5-e511-4ab8-aec9-9fd094ca8a7a",
          //       "name": "test",
          //       "legal_merchant_name": null,
          //       "legal_entity_type": null,
          //       "email": null,
          //       "website": null,
          //       "logo": "https://sendbee-dev.s3.amazonaws.com/a-captain-underpants-movie-is-on-the-way-03-e1482784107381.jpg",
          //       "plan": "1 x Monthly subscription ($250 USD / month), 1 x Template messages ($0.04 USD / month)",
          //       "plan_active": false,
          //       "slug": "test",
          //       "phone": "+1234567893",
          //       "unread_conversations": {
          //         "unassigned_unread": 0,
          //         "all_unread": 0,
          //         "user_unread": {
          //           "559a42d1-9662-430f-8664-8294bed16346": 0
          //         }
          //       },
          //       "address": "test",
          //       "about": "",
          //       "description": "",
          //       "available": false
          //     },
          //     {
          //       "id": "1f9730b7-bcdc-4547-9d92-4caa70a60643",
          //       "name": "AI Number",
          //       "legal_merchant_name": null,
          //       "legal_entity_type": null,
          //       "email": "ivan@number.tm ",
          //       "website": "https://number.tm ",
          //       "logo": "",
          //       "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)",
          //       "plan_active": true,
          //       "slug": "number",
          //       "phone": "+13253077759",
          //       "unread_conversations": {
          //         "unassigned_unread": 0,
          //         "all_unread": 0,
          //         "user_unread": {
          //           "559a42d1-9662-430f-8664-8294bed16346": 0
          //         }
          //       },
          //       "address": "Ulica BB",
          //       "about": "Ovo je tesni Number account.",
          //       "description": "Ovo je tesni Number account.",
          //       "available": false
          //     },
          //     {
          //       "id": "448867a5-e511-4ab8-aec9-9fd094ca8a7a",
          //       "name": "test",
          //       "legal_merchant_name": null,
          //       "legal_entity_type": null,
          //       "email": null,
          //       "website": null,
          //       "logo": "https://sendbee-dev.s3.amazonaws.com/a-captain-underpants-movie-is-on-the-way-03-e1482784107381.jpg",
          //       "plan": "1 x Monthly subscription ($250 USD / month), 1 x Template messages ($0.04 USD / month)",
          //       "plan_active": false,
          //       "slug": "test",
          //       "phone": "+1234567893",
          //       "unread_conversations": {
          //         "unassigned_unread": 0,
          //         "all_unread": 0,
          //         "user_unread": {
          //           "559a42d1-9662-430f-8664-8294bed16346": 0
          //         }
          //       },
          //       "address": "test",
          //       "about": "",
          //       "description": "",
          //       "available": false
          //     },
          //     {
          //       "id": "1f9730b7-bcdc-4547-9d92-4caa70a60643",
          //       "name": "AI Number",
          //       "legal_merchant_name": null,
          //       "legal_entity_type": null,
          //       "email": "ivan@number.tm ",
          //       "website": "https://number.tm ",
          //       "logo": "",
          //       "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)",
          //       "plan_active": true,
          //       "slug": "number",
          //       "phone": "+13253077759",
          //       "unread_conversations": {
          //         "unassigned_unread": 0,
          //         "all_unread": 0,
          //         "user_unread": {
          //           "559a42d1-9662-430f-8664-8294bed16346": 0
          //         }
          //       },
          //       "address": "Ulica BB",
          //       "about": "Ovo je tesni Number account.",
          //       "description": "Ovo je tesni Number account.",
          //       "available": false
          //     },
          //     {
          //       "id": "448867a5-e511-4ab8-aec9-9fd094ca8a7a",
          //       "name": "test",
          //       "legal_merchant_name": null,
          //       "legal_entity_type": null,
          //       "email": null,
          //       "website": null,
          //       "logo": "https://sendbee-dev.s3.amazonaws.com/a-captain-underpants-movie-is-on-the-way-03-e1482784107381.jpg",
          //       "plan": "1 x Monthly subscription ($250 USD / month), 1 x Template messages ($0.04 USD / month)",
          //       "plan_active": false,
          //       "slug": "test",
          //       "phone": "+1234567893",
          //       "unread_conversations": {
          //         "unassigned_unread": 0,
          //         "all_unread": 0,
          //         "user_unread": {
          //           "559a42d1-9662-430f-8664-8294bed16346": 0
          //         }
          //       },
          //       "address": "test",
          //       "about": "",
          //       "description": "",
          //       "available": false
          //     }
          // );
          // console.log(response.data);
          commit('CURRENT_ORGANISATION_SET_DATA', response.data);

          // get members and teams, we'll need them
          dispatch('fetchOrganisationMembers', organisationId);
          // dispatch('fetchOrganisationTeams', organisationId);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  setCurrentOrganisation({ dispatch }, organisation) {
    dispatch('fetchCurrentOrganisation', organisation.id);
    dispatch('fetchOrganisationMembers', organisation.id);
  },
  fetchFeatures({ commit, rootState }) {
    commit('CLEAR_FEATURES');
    const request = api('GET', `features/organisation/${rootState.organisation.currentOrganisation.id}`, null, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('SET_FEATURES', response.data);
        }
      });
    return request;
  },
  /** @deprecated */
  fetchOrganisationMembers({ commit, getters }, organisationId) {
    if (getters.currentOrganisationMembersLoading || Object.keys(getters.currentOrganisationMembersLookup).length) {
      return;
    }
    commit('ORGANISATION_MEMBERS_SET_LOADING');

    api('GET', `organisation/${organisationId}/members`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('ORGANISATION_MEMBERS_SET_DATA', response.data);
        }
      })
      .catch(() => { });
  },
  /**
   * Gets the organisation memebers list.
   * Has no paging, so it will get all members at once.
   * You can filter the live members or AI members by passing the type parameter inside payload.
   * @param {Object} payload Object with organisationId and type parameters.
   * @param {String} payload.organisationId Organisation ID
   * @param {String} [payload.type] Type of members to fetch. Can be 'members' or 'ai_assistants'.
   * @returns {Promise} Promise object represents the API request.
   */
  fetchOrganisationMembers2({ commit }, payload) {
    const request = api('GET', `organisation/${payload.organisationId}/members`, { type: payload.type }, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('ORGANISATION_MEMBERS_SET_DATA2', { data: response.data, type: payload.type });
        }
      })
      .catch(() => { });
    return request;
  },
  fetchAiAssistants({ commit, rootState }) {
    // const request = api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/members`, { type: 'ai_assistants' }, null, 'w');
    const request = api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/assistant/list`, null, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('SET_ORGANISATION_AI_ASSISTANTS', response.data);
        }
      })
      .catch(() => { });
    return request;
  },
  updateLocalAssistant({ commit }, payload) {
    commit('UPDATE_LOCAL_ASSISTANT', payload);
  },
  fetchOrganisationTeams({ commit }, organisationId) {
    commit('ORGANISATION_TEAMS_SET_LOADING');

    api('GET', `organisation/${organisationId}/teams`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          // commit to store
          commit('ORGANISATION_TEAMS_SET_DATA', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  clearStatistics({ commit }) {
    commit('CLEAR_STATISTICS');
  },
  /**
   * Method retrives statistics from the backend and its triggering is limited to have minimum time difference between two requests.
   * In some cases we need to override this minimum time limitation by using forceStatistics boolean parametar in payload.
   *
   * payload data structure
   * {
   *    organisationId: organisation id for which the statistics is requested,
   *    forceStatistics: flag to override min time between statistics
   * }
   *
   * @param {Object} payload - Payload data
   */
  fetchOrganisationStatistics({ commit, dispatch }, payload) {
    let request;
    if (payload.forceStatistics || canStatisticsBeReloaded) {
      request = api('GET', `/organisation/${payload.organisationId}/chat/statistics`, payload.data, null, 'w');
      request
        .then((response) => {
          if (response.status === 200) {
            resetStatisticsReloadTimer();
            Object.keys(response.data).forEach((key) => {
              commit('SET_STATISTICS', {
                merchant_id: key,
                data: response.data[key],
              });
              dispatch('chat/setInitialUnreadCounters', response.data, { root: true });
            });
          }
        })
        .catch((error) => {
          commit('API_ERROR', error.response);
        });
    } else {
      request = Promise.reject();
    }

    return request;
  },
  fetchOrganisationNumberStatistics({ commit, dispatch }, payload) {
    if (
      !payload.forced &&
      (
        !payload.businessId ||
        (!payload.forceStatistics && !canStatisticsBeReloaded)
      )
    ) {
      return;
    }
    api('GET', `/organisation/${payload.organisationId}/business/${payload.businessId}/chat/statistics`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          resetStatisticsReloadTimer();
          commit('SET_STATISTICS', {
            merchant_id: payload.businessId,
            data: response.data,
          });
          dispatch('chat/setInitialUnreadCounters', { [payload.businessId]: response.data }, { root: true });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  setMyAvailability({ commit, rootGetters }, { organisationId, isAvailable }) {
    // toggle avilable
    commit('SET_USER_AVAILABILITY_ON_CURRENT_ORGANISATION', isAvailable);
    api('PUT', `organisation/${organisationId}/user-availability`, { available: isAvailable }, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          // update user availability
          commit('UPDATE_MEMBER_AVAILABILITY', { memberId: rootGetters['user/id'], isAvailable });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
        commit('SET_USER_AVAILABILITY_ON_CURRENT_ORGANISATION', !isAvailable);
      });
  },
  setBusinessAvailability({ commit, rootState }, { businessId, isAvailable }) {
    commit('UPDATE_BUSINESS_AVAILABILITY', { businessId, isAvailable });
    const request = api('PUT', `organisation/${rootState.organisation.currentOrganisation.id}/business/${businessId}/availability`, { available: isAvailable }, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          // update user availability
          // commit('UPDATE_BUSINESS_AVAILABILITY', { businessId, isAvailable });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
        commit('UPDATE_BUSINESS_AVAILABILITY', { businessId, isAvailable: !isAvailable });
      });
    return request;
  },
  setOrganisationSplash({ commit }, payload) {
    commit('SET_SHOW_SPLASH');
    commit('SET_SPLASH_MESSAGE', payload.message);
  },
  hideOrganisationSplash({ commit }) {
    commit('SET_HIDE_SPLASH');
  },
  setSplashMessage({ commit }, message) {
    commit('SET_SPLASH_MESSAGE', message);
  },
  splashProgressIncrease({ commit }) {
    commit('INCREASE_SPLASH_PROGRESS');
  },
  finalizeSplashView({ commit, state, getters, rootGetters, dispatch }) {
    const userId = rootGetters['user/id'];
    const activate = getters.currentOrganisation && (getters.currentOrganisation.should_activate_account || getters.currentOrganisation.should_reactivate_account);
    // Only allow the splash to be removed if:
    //    - organisation needs Activation
    //    - user is not defined so login page is needed
    //    - organisation features are loaded
    if (activate || !userId || state.features.organisation_features) {
      commit('FINALIZE_SPLASH');
    } else {
      setTimeout(() => {
        dispatch('finalizeSplashView');
      }, 1000);
    }
  },
  memberRemovedFromOrganisation({ commit }, payload) {
    commit('REMOVE_MEMBER_FROM_ORGANISATION', payload);
  },
  numberChanged({ commit }, payload) {
    commit('CHANGE_NUMBER_DATA', payload);
  },
  organisationChanged({ commit }, payload) {
    commit('CHANGE_ORGANISATION_DATA', payload);
  },
  getOrgInfo({ commit }, organisationId) {
    // For now we will use only profile picture and a name which is available from the currentOrganisation
    // api('GET', `organisation/${organisationId}/info`, null, null, 'w');
  },
  loadOrganisationIntegrationsData({ commit, rootState }) {
    api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/integrations`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          response.data.forEach((r) => {
            // if (r.code === 'INMAIL') {
            //   r.measure_conversion_rate = true;
            // }
          });
          commit('SET_INTEGRATIONS_DATA', response.data);
        }
      });
  },
  fetchIntegrationsRegistry({ commit, rootState }) {
    api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/integrations/registry`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_INTEGRATIONS_REGISTRY_DATA', response.data);
        }
      });
  },
  fetchChannelsRegistry({ commit, rootState }) {
    api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/channels/registry`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_CHANNELS_DATA', response.data);
        }
      });
  },
  updateOrganisationInfo({ commit }, payload) {
    const request = api('PUT', `organisation/${payload.organisationId}/info`, payload.data, {
      'Content-Type': 'multipart/form-data',
    }, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('UPDATE_CURRENT_ORGANISATION', payload);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });

    return request;
  },
  setCurrentNumber({ commit }, numberId) {
    commit('SET_CURRENT_NUMBER', numberId);
  },
  setNumberUnreadCounter({ commit, rootGetters }, payload) {
    payload.userId = rootGetters['user/id'];
    payload.userCounter = payload.userCounter && parseInt(payload.userCounter, 10) > 0 ? payload.userCounter : 0;
    payload.counter = payload.counter && parseInt(payload.counter, 10) > 0 ? payload.counter : 0;
    commit('UPDATE_UNREAD_PER_NUMBER', payload);
  },
  updateMembersWithNumber({ commit }, payload) {
    commit('UPDATE_MEMBERS_WITH_NUMBER', payload);
  },
  incrementStatisticLocalData({ commit, rootGetters }, payload) {
    payload.allConversationsList = rootGetters['chat/allConversationsList'];
    commit('INCREMENT_STATISTIC_LOCAL_DATA', payload);
  },
  decrementStatisticLocalData({ commit, rootGetters }, payload) {
    payload.allConversationsList = rootGetters['chat/allConversationsList'];
    commit('DECREMENT_STATISTIC_LOCAL_DATA', payload);
  },
  updateStatisticLocalData({ commit, getters, rootGetters }, payload) {
    payload.folder = rootGetters['inbox/currentFolder'];
    payload.myId = getters.me.id;
    commit('UPDATE_STATISTIC_LOCAL_DATA', payload);
  },
  /** Resets counter for number.conversation to 0. */
  resetLocalCounter({ commit }, payload) {
    commit('RESET_LOCAL_COUNTER', payload);
  },
  /** Clears all statistic local data. */
  clearStatisticLocalData({ commit }) {
    commit('CLEAR_STATISTIC_LOCAL_DATA');
  },
  forceResync({ commit, dispatch }) {
    // console.log('LR: ', lastResync);
    const currentTime = (new Date()).getTime();
    if (lastResync && (lastResync + 120000) > currentTime) {
      // console.log('No resync');
      return;
    }
    lastResync = currentTime;
    commit('FORCE_RESYNC');
    dispatch('chat/reloadFirstPage', true, { root: true });
  },
  reloadOrganisationList({ state, commit }) {
    const request = api('GET', 'organisation/data', null, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('ORGANISATION_LIST_SET_DATA', response.data);
          const targetOrganisation = response.data.find(o => o.id === state.currentOrganisation.id);
          if (targetOrganisation) {
            commit('CURRENT_ORGANISATION_SET_DATA', targetOrganisation);
          } else {
            // If current orgaisation is not found in the new data set then just reload page.
            window.location.reload();
          }
        }
      });
  },
  paymentSuccessful({ commit }, data) {
    commit('MARK_INVOICE_AS_PAID', data);
    commit('PAYMENT_UPDATE', data);
  },
  paymentFailed({ commit }, data) {
    if (data.action === 'payment_failed_account_deactivated') {
      commit('DEACTIVATE_ORGANISATION', data);
    } else {
      commit('PAYMENT_UPDATE', data);
    }
  },
  importContacts({ commit, rootState }, payload) {
    const request = api('POST', `organisation/${rootState.organisation.currentOrganisation.id}/contacts/import`, payload, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('SET_IMPORT_ACTION', response.data);
        }
      });

    return request;
  },
  updateProgressAction({ commit }, payload) {
    commit('UPDATE_PROGRESS_ACTION', payload);
  },
  pauseAction({ commit, state }, payload) {
    commit('PAUSE_ACTION', payload);
    const numberSection = payload.numberId ? `/business/${payload.numberId}` : '';
    api('PUT', `/organisation/${state.currentOrganisation.id}${numberSection}/contacts/${payload.actionType}/${payload.actionId}`, { action: 'pause', action_by: payload.actionBy }, null, 'w')
      .then((response) => {
        if (response.status !== 200) {
          commit('CONTINUE_ACTION', payload);
          // TODO show error
        }
      })
      .catch((error) => {
        commit('CONTINUE_ACTION', payload);
        // TODO show error
      });
  },
  continueAction({ commit, state }, payload) {
    commit('CONTINUE_ACTION', payload);
    const numberSection = payload.numberId ? `/business/${payload.numberId}` : '';
    api('PUT', `/organisation/${state.currentOrganisation.id}${numberSection}/contacts/${payload.actionType}/${payload.actionId}`, { action: 'unpause', action_by: payload.actionBy }, null, 'w')
      .then((response) => {
        if (response.status !== 200) {
          commit('PAUSE_ACTION', payload);
          // TODO show error
        }
      })
      .catch((error) => {
        commit('PAUSE_ACTION', payload);
        // TODO show error
      });
  },
  cancelAction({ commit, state, dispatch }, payload) {
    commit('CLOSE_ACTION', payload);
    const numberSection = payload.numberId ? `/business/${payload.numberId}` : '';
    api('PUT', `/organisation/${state.currentOrganisation.id}${numberSection}/contacts/${payload.actionType}/${payload.actionId}`, { action: 'cancel', action_by: payload.actionBy }, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          dispatch('closeAction', payload);
        }
      });
  },
  closeAction({ commit, state }, payload) {
    commit('CLOSE_ACTION', payload);
    const numberSection = payload.numberId ? `/business/${payload.numberId}` : '';
    api('PUT', `/organisation/${state.currentOrganisation.id}${numberSection}/contacts/${payload.actionType}/${payload.actionId}`, { action: 'close', action_by: payload.actionBy }, null, 'w');
  },
  /** Action for manually checking the import state and data. */
  checkActionProgress({ commit, state }, payload) {
    const numberSection = payload.numberId ? `/business/${payload.numberId}` : '';
    const request = api('GET', `/organisation/${state.currentOrganisation.id}${numberSection}/contacts/${payload.actionType}/${payload.actionId}`, null, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          let data;
          let progress;
          let progressData = {
            progressId: null,
            stats: null,
            data: {
              subtitle: null,
              progress: null,
            },
          };

          let addToSend = 0;

          switch (payload.actionType) {
            case 'import':
              data = response.data.data;
              progress = data.progress.total_contacts ? Math.floor((data.progress.added_contacts + data.progress.duplicated_contacts + data.progress.failed_contacts.invalid_phone_format + data.progress.failed_contacts.other) / data.progress.total_contacts * 100) : 0;
              progressData = {
                progressId: data.id,
                stats: data.progress,
                data: {
                  subtitle: `${window.vueFilters.bigDigits(data.progress.added_contacts + data.progress.duplicated_contacts + data.progress.failed_contacts.invalid_phone_format + data.progress.failed_contacts.other)} of ${window.vueFilters.bigDigits(data.progress.total_contacts)}`,
                  progress,
                },
              };
              break;
            case 'broadcast':
              data = response.data;
              // These params from failed are also counted into sent as Ivan requested 23.5.2023 12:18
              ['contact_unsubscribed', 'invalid_phone', 'contact_blocked'].forEach((key) => { addToSend += Number(data.progress.failed[key]) || 0; });
              progress = data.progress.total ? Math.floor(data.progress.sent / data.progress.total * 100) : 0;
              progressData = {
                progressId: data.id,
                stats: data.progress,
                data: {
                  subtitle: `${window.vueFilters.bigDigits(Number(data.progress.sent) + addToSend)} of ${window.vueFilters.bigDigits(data.progress.total)}`,
                  progress,
                },
              };
              break;
            default:
              break;
          }
          if (progress < state.progressActions[data.id].progress) {
            progressData.data.progress = state.progressActions[data.id].progress;
          }

          switch (data.state) {
            case 'Paused':
              progressData.data.state = ProgressStates.PAUSED;
              break;
            case 'Running':
              progressData.data.state = ProgressStates.RUNNING;
              break;
            case 'Aborted':
              progressData.data.state = ProgressStates.FAILED;
              break;
            case 'Finished':
              progressData.data.state = ProgressStates.FINISHED;
              break;
            case 'Ready':
              progressData.data.state = ProgressStates.RUNNING;
              break;
            default:
              break;
          }
          if (progress === 100) {
            progressData.data.state = ProgressStates.FINISHED;
            switch (payload.actionType) {
              case 'import':
                progressData.data.title = 'Contacts imported';
                break;
              case 'broadcast':
                progressData.data.title = 'Broadcast sent';
                break;
              default:
                break;
            }
          }
          commit('UPDATE_PROGRESS_ACTION', progressData);
        }
      });
    return request;
  },
  markActionAsFailed({ commit, dispatch }, payload) {
    dispatch('pauseAction', payload);
    commit('FAIL_ACTION', payload);
  },
  setUnreadCounter({ commit }, count) {
    commit('SET_UNREAD_COUNTER', count);
  },
  setWebWidgets({ commit }, widgets) {
    commit('SET_WEB_WIDGETS', widgets);
  },
};

export default actions;
